import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { TopBar } from "./components/TopBar";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { MobileActionBar } from "./components/MobileActionBar";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import AboutPage from "./pages/AboutPage";
import ServiceAreasPage from "./pages/ServiceAreasPage";
import SuburbPage from "./pages/SuburbPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import GetEstimatePage from "./pages/GetEstimatePage";
import PrivacyPage from "./pages/PrivacyPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <div className="max-w-3xl mx-auto px-5 py-32 text-center" data-testid="not-found-page">
    <h1 className="font-display font-medium text-5xl tracking-tight text-brand-ink">Page not found</h1>
    <p className="mt-4 text-brand-muted">The page you're after doesn't exist — but your cleaning job still does.</p>
    <Link to="/" data-testid="not-found-home-link" className="mt-8 inline-flex items-center gap-2 bg-brand text-white font-semibold px-7 py-3.5 rounded-full text-sm">
      Back to Home
    </Link>
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-brand-bg text-brand-ink font-sans overflow-x-clip pb-[52px] md:pb-0">
        <TopBar />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/service-areas" element={<ServiceAreasPage />} />
            <Route path="/service-areas/:slug" element={<SuburbPage />} />
            <Route path="/faqs" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/get-estimate" element={<GetEstimatePage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/:slug" element={<ServicePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <MobileActionBar />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
